/**
 * @type {Smartplug}
 */
export const spPlaceholder = {
	Imei: "",
	LastUplinkAt: "",
	Consumption: 0,
	Load: 0,
	Temperature: 0,
	SignalStrength: 0,
	PowerEnabled: false,
	BeepEnabled: false,
	OfflineAlarm: {
		Enabled: false,
		Triggered: false,
	},
	PowerFailureAlarm: {
		Enabled: false,
		Triggered: false,
	},
	LoadAlarm: {
		Enabled: false,
		Lower: 0,
		Upper: 0,
		Triggered: false,
	},
	TemperatureRangeAlarm: {
		Enabled: false,
		Lower: 0,
		Upper: 0,
		Triggered: false,
	},
	Thermostat: {
		Enabled: false,
		Triggers: [],
	},
	Timer: {
		Enabled: false,
		On: [],
		Off: [],
	},
	Metadata: {
		OwnerEmail: "",
		Name: "",
		Tags: [],
		Access: [],
		Notify: [],
	},
	Subscription: {
		ExpiresAt: "",
		PriceIds: {
			Current: "",
			Next: "",
		},
		Trialing: false,
	},
};
